import type { ComponentProps } from "react";
import AudioChoiceItem from "./base/AudioChoiceItem";

type Props = Omit<ComponentProps<typeof AudioChoiceItem>, "multiSelect">;

const MultipleChoiceMultipleAnswerListening = (props: Props) => (
	<AudioChoiceItem {...props} multiSelect />
);

export default MultipleChoiceMultipleAnswerListening;
